<script type="text/ecmascript-6">
import TileQuestion from "./mixin/TileQuestion.vue";

export default {
    mixins: [
        TileQuestion,
    ],
    props: {
        title: {
            default() {
                return 'Select Cassette';
            }
        },
        component_id: {
            default() {
                return 'slab_cassette';
            }
        },
        slab: {
            required: true
        },
        typeRange: {
            required: false,
            default: 0,
        },
        fabricator: {
            required: true
        },
        show_empty_tiles: {
            default() {
                return false;
            }
        },
    },
    computed: {
        thumbURL() {
            return '/thumb/slab-cassette/';
        },
        url() {
            return '/api/options/' + this.fabricator + '/slab-cassettes?slab=' + this.slab + '&type_range=' + this.typeRange;
        },
        cache_key() {
            return '_' + this.slab + '_' + this.typeRange;
        },
        passed_filter() {
            return this.variable_ready(this.slab, this.typeRange);
        },
        panel_required() {
            return this.filtered_option_list.length > 1;
        },
    },
    watch: {
        'cache_key': function (val, oldVal) {
            this.update_options();
        },
    }
}
</script>
